import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { unpairKiosk } from '../../actions/kioskActions';
import { clearKioskSession, getKioskPlate } from '../../utils/kiosk';
import { push } from '../../utils/navigation';
import { BASE_URL } from '../../constants';
import '../../css/kiosk.css';

/**
 * Replaces the app header on a truck console.
 *
 * The normal header carries navigation and a user menu built for a mouse; on a panel in a cabinet
 * the only two things that matter are who is signed in and how to sign out at the end of a shift.
 */
class KioskBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = { signingOut: false };
    }

    signOut = () => {
        const { dispatch } = this.props;
        const plate = getKioskPlate(this.props.accessToken);

        this.setState({ signingOut: true });

        // Revoke server-side first: that is what actually ends the session and tells the office. The
        // local clear only stops this screen showing a signed-in driver.
        const revoke = plate ? dispatch(unpairKiosk(plate)) : Promise.resolve();

        return revoke
            .then(() => clearKioskSession())
            .then(() => {
                // Kiosk mode deliberately stays on: this browser is still a console, so it goes back
                // to the pairing screen rather than to a B2C sign-in nobody can complete here.
                dispatch(push(`${BASE_URL}/kiosk`));
                window.location.reload();
            })
            .catch(() => {
                this.setState({ signingOut: false });
                toastr.error('Sign out failed', 'Could not sign out. Try again.');
            });
    };

    render() {
        const { account } = this.props;
        const driverName = (account && account.user && account.user.name) || 'Signed in';
        const plate = getKioskPlate(this.props.accessToken);

        return (
            <div className="kiosk-bar">
                <div>
                    <span className="kiosk-bar-driver">{driverName}</span>
                    {plate ? <span className="ml-3 text-muted">{plate}</span> : null}
                </div>
                <button
                    className="btn btn-outline-light"
                    disabled={this.state.signingOut}
                    onClick={this.signOut}>
                    {this.state.signingOut ? 'Signing out…' : 'Sign out'}
                </button>
            </div>
        );
    }
}

KioskBar.propTypes = {
    account: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        account: state.account,
        accessToken: state.oidc && state.oidc.user ? state.oidc.user.access_token : null,
    };
}

export default connect(mapStateToProps)(KioskBar);
